import React from "react";
import BaseModalTransition from "@/src/components/Modal/BaseModalTransition";
import clsx from "clsx";

export type Props = React.PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  classes?: {
    background?: string;
    modal?: string;
  };
}>;
const BaseMarketplaceModal: React.FC<Props> = ({
  classes,
  children,
  isOpen,
  onClose,
}) => {
  return (
    <BaseModalTransition
      isOpen={isOpen}
      onClose={onClose}
      className={classes?.background}
      backgroundClassName={"bg-gray-950"}
    >
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full justify-center md:items-center">
          {/* We are not using Dialog Panel here, because we don't want clicking outside small modal area to close modal */}
          <div
            className={clsx("relative w-full", "bg-gray-950", classes?.modal)}
          >
            {children}
          </div>
        </div>
      </div>
    </BaseModalTransition>
  );
};

export default BaseMarketplaceModal;
